import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
export default function InfinityDe() {
  const [pressimages, setPressimages] = useState([]);
  

  // Bilder aus infinity.json laden
  useEffect(() => {
    const fetchImages = async () => {
      try {
        const res = await fetch('/data/infinity.json', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-store, no-cache, must-revalidate, max-age=0',
            'Pragma': 'no-cache'
          }
        });
        if (!res.ok) throw new Error('Fehler beim Laden von infinity.json');
        const json = await res.json();
        setPressimages(json.images || []);
      } catch (err) {
        console.error(err);
      } finally {
        
      }
    };

    fetchImages();
  }, []);

  

  return (
  
    <article className="container">
         <div className="lang-switch">
              <Link to="/Infinityen">
                <button>EN</button>
              </Link>
            </div>
     <header>
  <h1>Unendlichkeit des Lichtes</h1>
  <h2>Eine Lichtskulptur von Billi Thanner auf der Votivkirche, Wien</h2>
  <p className="illumination">
    Illuminierung: 16. Dezember 2025, abends<br />
    Laufzeit: bis 1. August 2026<br />
    Kurator: Dr. Walter Seidl
  </p>
</header>

<section className="text">
  <p>
    Symbole prägen Räume, Emotionen und kollektive Vorstellungen. Mit
    „Unendlichkeit des Lichtes“ erweitert Billi Thanner diese symbolische
    Dimension um eine neue, monumentale Setzung im öffentlichen Raum. Vier
    Jahre nach ihrer vielbeachteten Himmelsleiter kehrt die Künstlerin auf
    die Türme der Votivkirche zurück und knüpft an ihren Dialog zwischen
    Architektur, Wahrnehmung und urbanem Kontext an.
  </p>

  <p>
    Die 28 × 8 Meter große Aluminiumskulptur in Form einer liegenden Acht –
    seit der Antike Zeichen für Unendlichkeit – im warmweißen Licht verbindet
    mathematische Präzision mit poetischer Offenheit. Ein physikalischer
    Bezugspunkt bildet die Zeit, die ein Lichtstrahl von der Sonne zur Erde
    benötigt: acht Minuten. Thanner transformiert diese Konstante in eine
    räumliche Metapher für Kontinuität, Balance und Verbindung, ohne religiöse
    oder ideologische Überhöhung. „Das Werk öffnet einen Raum der Wahrnehmung
    – zwischen Konstruktion, Licht und uns Menschen“, erklärt Thanner.
  </p>

  <p>
    Die Skulptur tritt in einen lebendigen Dialog mit der neugotischen
    Architektur der Votivkirche und schafft einen zeitgenössischen Kontrast,
    der den Stadtraum neu akzentuiert. „Unendlichkeit des Lichtes ist nicht
    primär eine Aufforderung zum Hinsehen, sondern eine Erinnerung an das
    Licht, das uns verbindet“, sagt Billi Thanner.
  </p>

  <p>
    Das Kunstwerk entstand aus privater Finanzierung; die Künstlerin
    verzichtete auf Honorar sowie auf öffentliche und kirchliche Förderungen.
    In dieser Unabhängigkeit manifestiert sich Thanners konsequenter Anspruch,
    Kunst als freien, eigenständigen Impuls zu denken. Dazu meint die
    Künstlerin: „Kunst soll für alle sichtbar sein, die hinsehen wollen.“
  </p>

  <p>
    Im kunsthistorischen Diskurs bewegt sich die Arbeit zwischen Minimalismus,
    Lichtkunst und konzeptueller Skulptur. Die liegende Acht wird in eine
    architektonische Struktur überführt – eine horizontale Linie zwischen
    zwei vertikalen Türmen. Dadurch verhandelt das Werk grundlegende Fragen
    von Maßstab, Wahrnehmung und temporärer Kunst im öffentlichen Raum.
  </p>

  <p>
    Billi Thanner (1972) lebt und arbeitet in Wien und zählt zu den
    Protagonistinnen einer neuen Generation des zeitgenössischen
    Aktionismus, Neo-Aktionismus und Interaktionismus.
  </p>
   <br/> <br/> <br/>
  <p>
  Die folgenden Bilder stehen in hoher Auflösung zum Download zur Verfügung. 
  Sie können unter dem Link <Link to="/Pressphotos">Pressphotos</Link> heruntergeladen werden.
</p>
</section>




      <section className="gallery">
        <div className="grid">
          {pressimages.map((img, i) => (
            <figure key={i} className="card">
              <img src={img.url} alt={img.alt || ''} loading="lazy" />
              {img.title && <figcaption>{img.title}</figcaption>}
            </figure>
          ))}
        </div>
          <div className="back-button">
      <Link to="/">
        <button>zurück</button>
      </Link>

      <style jsx>{`
        .back-button {
          position: fixed;
          bottom: 20px;
          right: 20px;
          z-index: 1000;
        }

        .back-button button {
          background: #000;
          color: #fff;
          padding: 6px 14px;
          border-radius: 8px;
          font-size: 0.9rem;
          border: none;
          cursor: pointer;
          transition: opacity 0.25s ease;
        }

        .back-button button:hover {
          opacity: 0.8;
        }
      `}</style>
    </div>
      </section>

      <style jsx>{`
.container {
  max-width: 960px;
  margin: 0 auto;
  padding: 20px;
  line-height: 1.5;
  font-size: 15px;
  font-family: 'FreeSans', sans-serif;
  color: #222;
}

header h1 {
  font-size: 2.5rem;
  margin-bottom: 10px;
  font-weight: 700;
}

header h2 {
  font-size: 1.4rem;
  margin-bottom: 16px;
  color: #555;
  font-weight: 400;
}

.illumination {
  color: #888;
  font-size: 0.9rem;
  margin-bottom: 20px;
}

.lang-switch {
  position: absolute;
  top: 20px;
  right: 20px;
}

.lang-switch button {
  background: #000;
  color: #fff;
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 0.9rem;
  border: none;
  cursor: pointer;
  transition: opacity 0.25s ease;
}

.lang-switch button:hover {
  opacity: 0.8;
}
.text p {
  margin-bottom: 0.9em;
  font-size: 0.95rem;
  color: #333;
}

h3 {
  margin-top: 2.5em;
  font-size: 1.8rem;
  color: #222;
  font-weight: 600;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
  margin-top: 32px;
}

figure {
  margin: 0;
  overflow: hidden;
  border-radius: 6px;
  background-color: #f5f5f5;
}

img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
}

img:hover {
  transform: scale(1.03);
}

figcaption {
  padding: 8px 10px;
  font-size: 0.85rem;
  color: #555;
}

/* Mobile Styles */
@media (max-width: 600px) {
  .container {
    padding: 16px;
    font-size: 14px;
    line-height: 1.4;
  }

  .text p {
    font-size: 0.78rem; /* noch kleiner für Mobile */
    margin-bottom: 0.8em;
  }

  .illumination {
    font-size: 0.85rem;
  }

  header h1 {
    font-size: 1.8rem;
  }

  header h2 {
    font-size: 1.1rem;
  }

  h3 {
    font-size: 1.4rem;
  }

  .grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  figcaption {
    font-size: 0.8rem;
  }
}
      `}</style>
    </article>
  );
}